"use strict";

var HasRounds = {
  data: function data() {
    return {
      minMax: {},
      age: Fn.getAge(window.globals.user.date_of_birth),
      gender: window.globals.user.gender
    };
  },
  mounted: function mounted() {
    this.minMax = this.calculateMaxMin(this.question.references);
  },


  computed: {
    isInYellowRange: function isInYellowRange() {
      var _minMax = this.minMax,
          min = _minMax.min,
          max = _minMax.max,
          minGreen = _minMax.minGreen,
          maxGreen = _minMax.maxGreen;


      if (min != null && minGreen != null && +this.value >= +min && +this.value < +minGreen) {
        return true;
      }

      if (max != null && maxGreen != null && +this.value > +maxGreen && +this.value <= +max) {
        return true;
      }

      return false;
    },
    isInRange: function isInRange() {
      var max = this.minMax.max == null ? Number.MAX_VALUE : this.minMax.max;
      var min = this.minMax.min == null ? Number.MIN_VALUE : this.minMax.min;

      return +this.value >= +min && +this.value <= +max;
    },
    range: function range() {
      var _minMax2 = this.minMax,
          min = _minMax2.min,
          max = _minMax2.max,
          minGreen = _minMax2.minGreen,
          maxGreen = _minMax2.maxGreen;


      if (minGreen && maxGreen && min && max) {
        return "\n                    <span class=\"c-red mb-min\">&lt;" + min + " " + this.$t("common.words.or") + " &gt;" + max + "</span>\n                    </br>\n                    <span class=\"c-yellow mb-min\">&gt;=" + min + " " + this.$t("common.words.and") + " &lt;" + minGreen + " " + this.$t("common.words.or") + " &gt;" + maxGreen + " " + this.$t("common.words.and") + " &lt;=" + max + "</span>\n                    </br>\n                    <span class=\"c-green mb-min\">&gt;=" + minGreen + " " + this.$t("common.words.and") + " &lt;=" + maxGreen + "</span>\n                    </br>\n                ";
      }

      if (min == null && max != null) {
        return "<span class=\"c-green\"><=" + max + "</span>";
      } else if (max == null && min != null) {
        return "<span class=\"c-green\">>=" + min + "</span>";
      } else if (min == null && max == null) {
        return "<span>-</span>";
      } else {
        return "<span class=\"c-green\">" + min + " - " + max + "</span>";
      }
    },
    statusClass: function statusClass() {
      if (!this.value || Object.values(this.minMax).every(function (value) {
        return value == null;
      })) {
        return false;
      }

      if (this.isInYellowRange) {
        return "yellow";
      }

      return this.isInRange ? "green" : "red";
    },
    answer: function answer() {
      if (this.question.type === "boolean") {
        if (this.value === undefined) {
          return "";
        }

        return this.value == "1" ? this.$t("tests.messages.yes_answer") : this.$t("tests.messages.no_answer");
      }

      if (this.question.element === "checkbox") {
        var answers = _.pick(this.question.alternatives, this.value);

        return _.values(_.mapValues(answers, function (o) {
          return o.text;
        })).join(", ");
      }

      return this.value;
    }
  },

  methods: {
    calculateMaxMin: function calculateMaxMin(references) {
      var _this = this;

      var minMax = {
        min: null,
        minGreen: null,
        max: null,
        maxGreen: null
      };
      var stop = false;
      _(references).forEach(function (reference) {
        if (stop) {
          return false;
        }
        switch (reference.attribute) {
          case "general":
            _this.setMinMax(reference, minMax);
            stop = true;
            break;
          case "gender":
            if (reference.attributeValue == _this.gender) {
              minMax = _this.setMinMax(reference, minMax);
            }
            break;
          case "age":
            var betweenMax = reference.betweenMax == null ? Number.MAX_VALUE : reference.betweenMax;
            var betweenMin = reference.betweenMin == null ? Number.MIN_VALUE : reference.betweenMin;

            if (betweenMax >= _this.age && betweenMin <= _this.age) {
              minMax = _this.setMinMax(reference, minMax);
            }
            break;
        }
      });

      return minMax;
    },
    setMinMax: function setMinMax(reference, minMax) {
      minMax.min = reference.min;
      minMax.minGreen = reference.minGreen;
      minMax.max = reference.max;
      minMax.maxGreen = reference.maxGreen;

      return minMax;
    }
  }
};

module.exports = HasRounds;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/mixins/HasReferences.js
// module id = DjrY
// module chunks = 0 1